export const base64toObjectURL = (data) => {
  const bytes = atob(data);
  let length = bytes.length;
  let out = new Uint8Array(length);

  while (length--) {
    out[length] = bytes.charCodeAt(length);
  }
  const blob = new Blob([out], { type: 'application/pdf' });
  return URL.createObjectURL(blob);
};
